import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { Meta, Title } from '@angular/platform-browser';
import { DataService } from 'src/app/services/data.service';
import { AESEncryptionService } from 'src/app/services/aesencryption.service';

declare let $: any;

export function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const s = document.createElement('script');
    s.src = src;
    s.onload = () => resolve();
    s.onerror = reject;
    document.body.appendChild(s);
  });
}


@Component({
  selector: 'app-webinar',
  templateUrl: './webinar.component.html',
  styleUrls: ['./webinar.component.css']
})
export class WebinarComponent implements OnInit  {
  webinar_banner_title: string = '';
  webinar_banner_desc: string = '';
  webinar_header_section: any = '';
  webinar_testimonial_section: any = '';
  featured_speaker: any = '';
  upcomingWebinars: any[] = [];
  upcomingNextWebinar: any;
  upcomingWebinarSpeakerName: string = '';
  upcomingWebinarTitle: string = '';
  upcomingWebinarSpeakerDate: any = '';
  upcomingWebinarLanguage: any = '';
  upcomingWebinarSpeakerDuration: any = '';
  upcomingWebinarSpeakerImg: any = '';
  nid: any = '';
  title: any = '';
  date_time: any = '';
  duration: any = '';
  isValidName: boolean = true;
  name: string = '';
  email: any = '';
  mobile: string = '';
  pincode:string='';
  webinar_id: number = 1;
  webinar_hindi: number = 0;
  isBajajEmp: boolean = false;
  isBajajEmpVal: any;
  rmcode: any = "";
  isToggle: boolean = false;
  isTogglevalue: any;
  nameValidateMessage: string = '';
  emailValidateMessage: any = '';
  mobileValidateMessage: any = '';
  pincodeValidateMessage: any = '';
  rmcodeValidateMessage: any = "";
  visitorId: any;
  leadId: string = '';
  thankyou: boolean = false;
  myleadform: boolean = true;
  otp: any = '';
  otpValidateMessage: string = '';
  generateotp: boolean = false;
  invalidOtpStatus: boolean = false;
  otpVerified: boolean = false;
  otpVerifiedFlag: boolean = false;
  isResendOTP: boolean = false;
  isButtonDisabled = false;
  otpVerify: string = "";
  isVisitorCreated = false;
  dataSuccess: any;
  isTimer: boolean=false;
  isResend: boolean = false;
  timeleft: number=0;
  intervalId: any;
  clickedResend: number=0;
  resendBtnTimer: number=0;
  selectedDate: any = ''
  meta_title: string = '';
  meta_desc: string = '';
  meta_keywords: string = '';
  currentWebinarCancelled: number = 0;
  joinTime: boolean = false;
  downloadfile: boolean = false;
  loginOTP: boolean = false;
  registrationOTP: boolean = false;
  webinarsucess: any;
  Firstregister: boolean = true;
  wdate: any;
  uniqueWebinar: boolean = false;
  uuid:any='';
  visitortype: any;

  constructor(@Inject(DOCUMENT) private readonly document: Document, private readonly service: DataService, private readonly router: Router, private readonly titleService: Title, private readonly metaService: Meta, private readonly _encryptionService: AESEncryptionService, private readonly route: ActivatedRoute, private readonly renderer: Renderer2) { }

  ngOnInit(): void {
    // Async initialization wrapped in IIFE to avoid returning a Promise from ngOnInit (S6544)
    void (async () => {
      try {
        await Promise.all([
          loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.2.4/gsap.min.js'),
          loadScript('https://www.bajajcapital.com/assets/js/owl.carousel.min.js')
        ]);
      } catch (e) {
        console.error('Failed to load lazy scripts:', e);
      }

      this.wdate = this.GetParameterValues('webinarCode');
      if (this.wdate) {
        this.wdate = this._encryptionService.base64Decode(this.wdate);
      }
      sessionStorage.removeItem('webinar_ended');

      this.metaForSEO("nps-webinar");
      if (sessionStorage.getItem('visitorId')) {
        this.visitorId = '';
        sessionStorage.setItem('visitorId', '');
      }
      setTimeout(() => {
        // otp field manage
        let otpdiv = $('#otpdiv');
        let editnumber = $('#editnumber');
        let mobileDivId = $('div#mobile_number');
        let send_otp = $('#send_otp');
        $(send_otp).click(function () {
          $(mobileDivId).animate({ "opacity": "hide", right: "100" }, 500);
          $(otpdiv).animate({ top: "0" }, 500);
          $(otpdiv).animate({ "opacity": "show", right: "0" }, 1000);
          $(mobileDivId).animate({ "opacity": "hide", top: "-80" }, 1200);
        })
        $(otpdiv).css({ "top": "-80px", "right": "-100%" });
        $(editnumber).click(function () {
          $(otpdiv).animate({ "opacity": "hide", right: "-400" }, 1000);
          $(mobileDivId).animate({ top: "0" }, 1000);
          $(mobileDivId).animate({ "opacity": "show", right: "0" }, 1000);
        })
        // otp field manage
      }, 200);

      this.createVisitor();
      this.getRetirementWebinarHomepageNewData();
      this.getRetirementWebinarSpeakersNew();
      this.getUpcomingWebinars();
      $('footer').css('margin-top', '0');

      let darktoggle = document.querySelectorAll(".dark-toggle");
      $(darktoggle).hide();
    })();
  }

  metaForSEO(slugname: string) {
    this.service.getDynamicMeta().subscribe(
      (data: any) => {
        const seoPages = data['rows'][0].seo_pages;
        for (const element of seoPages) {
          const v = element;
          if (v.seo_slug === slugname || v.seo_slug === '/' + slugname) {
            this.meta_title = v.seo_title;
            this.meta_desc = v.seo_description;
            this.meta_keywords = v.seo_keywords;
            this.titleService.setTitle(this.meta_title);
            this.metaService.removeTag('name="keywords"');
            this.metaService.removeTag('name="description"');
            this.metaService.addTags([
              { name: 'keywords', content: this.meta_keywords },
              { name: 'description', content: this.meta_desc },
              { name: 'robots', content: 'index, follow' },
            ]);
            break; // Exit the loop early
          }
        }
      },
      (err: any) => {
        console.error('Error fetching meta data:', err);
      }
    );
  }
  
  

  getRetirementWebinarHomepageNewData() {
    this.service.getRetirementWebinarHomepageNew().subscribe((data: any) => {
      this.webinar_banner_title = data.rows[0]['webinar_banner_title'];
      this.webinar_banner_desc = data.rows[0]['webinar_banner_desc'];
      this.webinar_header_section = data.rows[0]['webinar_header_section'];
      this.webinar_testimonial_section = data.rows[0]['webinar_testimonial_section'];

      setTimeout(() => {
        const script = this.document.createElement('script');
        script.src = './assets/js/marquee.js';
        this.document.head.appendChild(script);
      }, 1000)
    })
  }

  getRetirementWebinarSpeakersNew() {
    this.service.getRetirementWebinarSpeakersNew().subscribe((data: any) => {
      this.featured_speaker = data.rows.filter((speaker:any) => speaker.webinar_speaker_status === "1");
      const scripts = this.document.createElement('script');
      scripts.src = './assets/js/retirement-webinar.js';
      this.document.head.appendChild(scripts);
    })
  }

  getUpcomingWebinars() {
    let dateTime = '';
    if (this.wdate) {
     this.wdate = decodeURIComponent(this.wdate);
      dateTime = this.wdate;
      this.uniqueWebinar = true;
      // Validate dateTime format
      const dateTimeFormat = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
      const currentDate = new Date();
      const webinarDate = new Date(dateTime);
      // Reset time components to zero
      currentDate.setHours(0, 0, 0, 0);
      webinarDate.setHours(0, 0, 0, 0);

      // Compare todayDateTime with dateTime
      if (!dateTimeFormat.test(dateTime) || currentDate > webinarDate) {
        $('#uniqueWebinarErr').addClass('error')
        this.uniqueWebinar = false;
        setTimeout(() => {
          $('#uniqueWebinarErr').removeClass('error')
          sessionStorage.removeItem('date');
            // Remove 'wdate' parameter from URL
            const url = new URL(window.location.href);
            url.searchParams.delete('webinarCode');
            window.history.replaceState({}, document.title, url.toString());
            this.ngOnInit();
        }, 5000);
        return;
      }
    }
    else {
      const currentDate = new Date();
      dateTime = moment(currentDate).format("YYYY-MM-DD 00:00:00");
    }
    this.service.getRetirementWebinars(dateTime).subscribe((data: any) => {
      const currentDate = new Date();
      if(this.uniqueWebinar && data.rows.length==0){
        $('#uniqueWebinarErr').addClass('error')
        this.uniqueWebinar = false;
        setTimeout(() => {
          $('#uniqueWebinarErr').removeClass('error')
          sessionStorage.removeItem('date');
          // Remove 'wdate' parameter from URL
          const url = new URL(window.location.href);
          url.searchParams.delete('webinarCode');
          window.history.replaceState({}, document.title, url.toString());
          this.ngOnInit();
        }, 5000);
        return;
      } else if(this.uniqueWebinar && data.rows.length>0) {
        const webinarDate = new Date(data.rows[0].Webinar_datetime);
        const webinarEndDate = new Date(webinarDate.getTime() + data.rows[0].Webinar_duration * 60000);
        if(this.uniqueWebinar && (data.rows[0].Webinar_datetime != this.wdate || currentDate>webinarEndDate || data.rows[0].Webinar_completed == 1)){
            $('#uniqueWebinarErr').addClass('error')
            this.uniqueWebinar = false;
            setTimeout(() => {
              $('#uniqueWebinarErr').removeClass('error')
              sessionStorage.removeItem('date');
              // Remove 'wdate' parameter from URL
              const url = new URL(window.location.href);
              url.searchParams.delete('webinarCode');
              window.history.replaceState({}, document.title, url.toString());
              this.ngOnInit();
            }, 5000);
            return;
          }
      }

      const upcomingWebinars = data.rows
        .filter((webinar:any) => webinar.Webinar_completed === "0")
        .filter((webinar:any) => {
          const webinarDate = new Date(webinar.Webinar_datetime);
          const webinarEndDate = new Date(webinarDate.getTime() + webinar.Webinar_duration * 60000); // assuming Webinar_duration is in minutes
          return webinarEndDate > currentDate;
        });
      this.upcomingWebinars = upcomingWebinars.slice(0, 3);
      this.upcomingNextWebinar = upcomingWebinars.slice(0, 1);
      if (this.upcomingNextWebinar[0]) {
        this.upcomingWebinarTitle = this.upcomingNextWebinar[0]['webinar_title'];
        this.upcomingWebinarSpeakerName = this.upcomingNextWebinar[0]['webinar_speaker_section'][0]['speaker_name'];
        this.upcomingWebinarSpeakerImg = this.upcomingNextWebinar[0]['webinar_speaker_section'][0]['image'];
        this.upcomingWebinarSpeakerDate = this.upcomingNextWebinar[0]['Webinar_datetime'];
        this.upcomingWebinarLanguage = this.upcomingNextWebinar[0]['Webinar_language_hindi'];
        this.upcomingWebinarSpeakerDuration = this.upcomingNextWebinar[0]['Webinar_duration'];
      }

      if (this.wdate) {
        const wdate = new Date(this.wdate);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const day = wdate.getDate();
        const month = monthNames[wdate.getMonth()];
        const year = wdate.getFullYear();
        const formattedDate = `${day} ${month} ${year}`;
        this.handleButtonClick(this.upcomingNextWebinar[0]);
        $('#heading').text(`Register for Webinar, ${formattedDate}`);
        $('.statusBar').css('width', '100%');
      }

    });

    setTimeout(() => {
      let owl = $('.owl-ten').owlCarousel({
        loop: false,
        items: 1,
        margin: 20,
        mouseDrag: false,
        touchDrag: false,
        dots: false
      });
      $('.owlPrev').click(function () {
        owl.trigger('prev.owl.carousel');
      })
      $('.owlNext').click(function () {
        owl.trigger('next.owl.carousel');
      })
    }, 1200)

  }


  isImage(url:any) {
    let myurl = url?.toLowerCase();
    if (myurl.match(/\.(jpeg|jpg|webp|png)$/)) {
      return true;
    } else {
      return false;
    }
  }

  handleButtonClick(item: any) {
    this.nid = item.nid;
    this.title = item.webinar_title;
    this.webinar_id = item.webinar_id;
    this.webinar_hindi = item.Webinar_language_hindi
    this.date_time = item.Webinar_datetime;
    this.duration = Number.parseInt(item.Webinar_duration);
    const currentDate = moment().format('YYYY-MM-DD HH:mm:ss');
    sessionStorage.setItem('date', item.Webinar_datetime);
    const webinarDatetime = moment(item.Webinar_datetime, 'YYYY-MM-DD HH:mm:ss');
    const newDatetime = webinarDatetime.add(this.duration, 'minutes');
    const newTime = newDatetime.format('HH:mm:ss');
    this.downloadfile = true;

    if (currentDate > item.Webinar_datetime && newTime < currentDate) {
      this.joinTime = true;
      this.downloadfile = false;
    }
    this.selectedDate = sessionStorage.getItem('date');
  }

  numbersOnlyotp($event: any) {
    return /^[0-9]$/.test($event.key);
  };


  // Registaryion process start here 
  createVisitor() {
    let jscd = window['jscd'];
    if (!sessionStorage.getItem('visitorId')) {
      let obj = {
        "browsername": jscd?.browser,
        "browserversion": jscd?.browser + ' ' + jscd?.browserVersion,
        "operatingsystem": jscd?.os + " " + jscd?.osVersion,
        "device": jscd?.os,
        "sourceurl": window.location.href,
        "productid": '46',
        "visitortype": "NPS-webinar",
        "utmsource": this.GetParameterValues("utm_source"),
        "utmmedium": this.GetParameterValues("utm_medium"),
        "leadsource": this.GetParameterValues("lead_source"),
        "utmcampaign": this.GetParameterValues("utm_campaign"),
      };
      this.visitortype = "NPS-webinar"; // VISITOR TYPE
      this.service.createVisitor(obj).subscribe((data:any) => {
        this.visitorId = data["visitorId"];
        sessionStorage.setItem('visitorId', data["visitorId"]);
      }, err => {
        console.log(err);
        throw err;
      })
    } else {
      this.visitorId = sessionStorage.getItem('visitorId')
    }
  }

  createLead() {
    let leadid = sessionStorage.getItem('leadId');
    let obj = {
      "visitorid": this.visitorId,
      "leadid": leadid ? leadid : 0,
      "name": this.name,
      "email": this.email,
      "mobile": this.mobile,
    }
    this.service.createLead(obj).subscribe((data:any) => {
      sessionStorage.setItem('leadId', data['leadid'])
      this.leadId = data['leadid'];
      this.sendOtp();
    }, err => {
      console.log(err);
    })
  }

  generateOtp() {
    this.otpVerified = false;
    if (sessionStorage.getItem('leadId')) {
      this.leadId = '';
      sessionStorage.removeItem('leadId')
    }
    if (this.mobile && this.mobile.length != 10) {
      this.mobileValidateMessage = "lengthError";
    }
    else if (sessionStorage.getItem('visitorId')) {
      this.otp = '';
      document.getElementById("timer")!.style.display = 'block';
      this.otpValidateMessage = '';
      this.createLead();
      this.createVisitor();
      this.startTimer();
      this.clickedResend++;
    }
  }

  verifyOtp() {
    if (this.otp && this.otp.length < 6) {
      this.invalidOtpStatus = true;
    }
    if (this.otp.length >= 6) {
      {
        this.service.verifyOtp({ leadid: this.leadId, otp: this.otp }).subscribe(data => {
          this.dataSuccess = data["success"];
          if (this.dataSuccess) {
            this.registrationOTP = true;
            this.invalidOtpStatus = false;
            this.otpVerified = true;
            this.otpVerify = 'OTP Verified';
            if (this.otpVerify) {
              document.getElementById("timer")!.style.display = 'none';
            }
            setTimeout(() => {
              this.otpVerify = "";
            }, 5000);
            this.otpValidateMessage = '';
          } else {
            this.invalidOtpStatus = true;
          }
        }, err => {
          console.log(err);
        })
      }
    }
  }

  showGenerateOtpBtn() {
    this.mobile.length === 10 && this.isMobileWrong(this.mobile) ? document.getElementById('generateOtp')!.style.display = 'block' : document.getElementById('generateOtp')!.style.display = 'none';
  }

  validateBusinessCode($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0') {
        return false;
      }
    }
    let reg = /^[0-9]+$/;
    return (reg.test($event.key));
  }

  sendOtp() {
    this.service.sendOtp({ leadid: this.leadId, mobile: this.mobile }).subscribe();
  }

  resendOTP() {
    this.sendOtp();
    this.startTimer()
    this.clickedResend++;
    // document.getElementById("resendbutton").style.display = "none";
    document.getElementById("timer")!.style.display = "block";
  }

  startTimer() {
    clearInterval(this.intervalId);
    this.invalidOtpStatus = false;
    this.timeleft = 20;
    this.isTimer = true;
    this.isResend = false;
    this.intervalId = setInterval(() => {
      if (this.timeleft === 0) {
        clearInterval(this.intervalId);
        this.isTimer = false;
        if (this.clickedResend === this.resendBtnTimer) {
          this.isResend = false;
        } else {
          this.isResend = true;
        }
      }
      this.timeleft -= 1;
    }, 1000);
  }

  tablelead() {
    document.getElementById("main_loader")!.style.display = 'block';
    setTimeout(() => {
      // this.myleadform = false;
      this.thankyou = true;
      // document.getElementById("main_loader")!.style.display = 'none';
    }, 500);
    this.submit();
    
    this.otp = '';
    // this.mobile = '';
  }

  submit() {
    if (this.isBajajEmp === true) {
      this.isBajajEmpVal = 1;
    } else {
      this.isBajajEmpVal = 0;
      this.rmcode = '';
    }

    if (this.isToggle === true) {
      this.isTogglevalue = 1;
    } else {
      this.isTogglevalue = 0;
    }

    const webinarUrl = this.generateUniqueUrl(this.mobile, this.nid);
    sessionStorage.setItem('mobile', this.mobile)
    this.mobile = this.mobile
    sessionStorage.setItem('registerMobile', this.mobile)
    let obj = {
      "lead_id": this.leadId,
      "webinar_title": this.title,
      "webinar_date_time": this.date_time,
      "name": this.name,
      "mobile": this.mobile,
      "email": this.email,
      "pincode": this.pincode,
      "is_plan_generated": this.isTogglevalue,
      "is_employee": this.isBajajEmpVal,
      "emp_code": this.rmcode ? this.rmcode : '',
      "webinar_nid": this.nid,
      "webinar_duration": this.duration,
      "webinar_url": webinarUrl,
      "webinar_id": this.webinar_id,
      "webinar_type":2,
      "uuid":this.uuid,
      "webinar_hindi": this.webinar_hindi,
      "utmsource": this.GetParameterValues("utm_source"),
      "utmmedium": this.GetParameterValues("utm_medium"),
      "leadsource": this.GetParameterValues("lead_source"),
      "utmcampaign": this.GetParameterValues("utm_campaign")
    }
    this.service.webinarLeadsNew(obj).subscribe((data:any) => {
      if (data['success']) {
        this.postdata();
       }
      else if (!data['success']) {
        if (!this.otpVerifiedFlag) {
          $('#verifyFirst').addClass('error')
          setTimeout(() => {
            $('#verifyFirst').removeClass('error')
          }, 5000);
        } else {
            $('#alreadyregister').addClass('error')
            setTimeout(() => {
              $('#alreadyregister').removeClass('error')
            }, 5000);
          
        }

      }
    })
  }

  postdata() {
    if (this.isBajajEmp === true) {
      this.isBajajEmpVal = 1;
    } else {
      this.isBajajEmpVal = 0;
    }

    if (this.isToggle === true) {
      this.isTogglevalue = 1;
    } else {
      this.isTogglevalue = 0;
    }
    let utm_source = this.GetParameterValues("utm_source");
    let utm_medium = this.GetParameterValues("utm_medium");
    let utm_campaign = this.GetParameterValues("utm_campaign");

    this.service.pushLeadToLSQWebinar({
      visitor_type: this.visitortype,
        Name: this.name,
        Mobile: this.mobile,
        Email: this.email,
        Pincode: this.pincode,
        webinar_title: this.title,
        webinar_starttime: this.date_time,
        is_employee: this.isBajajEmpVal,
        webinar_nid: this.nid,
        webinar_id: this.webinar_id,
        webinar_hindi: this.webinar_hindi,
        webinar_duration: this.duration,
        webinar_status: "Registered",
        Landing_Page_URL: window.location.href,
        RMCode: this.rmcode ? this.rmcode : '',
        LEADID: this.leadId,
        webinar_type: 2,
        LeadSource:'Digital Marketing',
        Sub_LeadSource:utm_source || 'Website',
        Campaign_Name: 'NPS-Webinar',
        Product: "National Pension Scheme",
        Utm_Source: utm_source || '',
        Utm_Medium: utm_medium || '',
        Utm_Campaign: utm_campaign || 'NPS-Webinar',
        Entity_Type: 'Digital_BCL',
      }).subscribe((res:any) => {
        if (res["success"]) {
          let lsq_id = res['id'];
          sessionStorage.setItem('LSQ_id', lsq_id);
        }
      }, (err: any) => {
        console.log(err);
      })
  }


  checkValidationMsg(leadForm: NgForm) {
    let num: number = 0;
    this.name = leadForm.value.name.trim();
    this.email = leadForm.value.email.trim();
    this.mobile = leadForm.value.mobile.trim();
    this.pincode = leadForm.value.pincode.trim();
    // this.rmcode = leadForm.value.rmcode.trim();

    if (this.name && this.name.length < 3) {
      this.nameValidateMessage = "lengthError";
      num += 1;
    }
    if (!this.name) {
      this.nameValidateMessage = "required";
      num += 1;
    }
    if (!this.isValidName) {
      this.nameValidateMessage = "lengthError";
      num += 1;
    }
    if (this.email && this.validateEmailAddress() == 0) {
      this.emailValidateMessage = "invalid";
      num += 1;
    }
    if (!this.email) {
      this.emailValidateMessage = "required";
      num += 1;
    }
    if (this.isMobileWrong(this.mobile) == 0) {
      this.mobileValidateMessage = "invalid";
      num += 1;
    }
    if (!this.mobile) {
      this.mobileValidateMessage = "required";
      num += 1;
    }
    if (this.mobile && this.mobile.length != 10) {
      this.mobileValidateMessage = "lengthError";
      num += 1;
    }

    // if (leadForm.value.rmcode && leadForm.value.rmcode.trim() !== '') {
    //   if (!this.rmcode) {
    //     this.rmcodeValidateMessage = "required";
    //     num += 1;
    //   }
    //   else if (this.rmcode && this.rmcode.length < 5) {
    //     this.rmcodeValidateMessage = "invalid";
    //     num += 1;
    //   } else {
    //     this.rmcodeValidateMessage = '';
    //   }
    // }

    if (this.mobile?.length == 10 && !this.otp) {
      this.otpValidateMessage = "required";
      this.mobileValidateMessage = "verifyOtp";
      this.otpVerifiedFlag = false;
      num += 1;
    }

    if (this.otp && this.otp.length != 6) {
      this.otpValidateMessage = "lengthError";
      num += 1;
    }

    if (this.otp?.length == 6 && this.registrationOTP == false) {
      this.invalidOtpStatus = true;
      num += 1;
    }

    if (this.pincode && this.pincode.length < 6) {
      this.pincodeValidateMessage = "invalid";
      num += 1;
    }
    if (!this.pincode) {
      this.pincodeValidateMessage = "required";
      num += 1;
    }

    if (num > 0) {
      return false;
    }

    this.otpVerifiedFlag = true;
    return;
  }

  checkName(event: any) {
    const name = event.target.value
    const regexPatterns = [
      /^(?!abcd|bcde|cdef|defg|efgh|fghi|ghij|hijk|ijkl|jklm|klmn|lmno|mnop|nopq|opqr|pqrs|qrst|rstu|stuv|tuvw|uvwx|vwxy|wxyz|qwer|qwerty|asdf|asdfg|zxcv|zxcvb).*$/,
      /^(?!.*(.)\1\1).*$/,
      /^[a-zA-Z ]*$/
    ]
    const validName = regexPatterns.every(pattern => pattern.test(name));
    if (validName) {
      this.isValidName = true
    } else {
      this.isValidName = false
    }
  }

  showVerifyOtpErr() {
    $('#verifyFirst').addClass('error')
    setTimeout(() => {
      $('#verifyFirst').removeClass('error')
    }, 5000);
  }

  removeErrorMsg(fieldname: string) {
    if (fieldname == "name") {
      this.nameValidateMessage = "";
    }
    if (fieldname == "mobile") {
      this.mobileValidateMessage = "";
    }
    if (fieldname == "email") {
      this.emailValidateMessage = "";
    }
    if (fieldname == "otp") {
      this.otpValidateMessage = "";
    }
    if (fieldname == "pincode") {
      this.pincodeValidateMessage = "";
    }
  }

  isMobileWrong(mobile: string) {
    let firstDigit = mobile.substr(0, 1);
    if (firstDigit != '6' && firstDigit != '7' && firstDigit != '8' && firstDigit != '9') {
      return 0;
    }
    else if (mobile.match(/(\w)\1{9,}/)) {
      document.getElementById('generateOtp')!.style.display = 'none';
      return 0;
    }
    else {
      return 1;
    }
  }

  validateEmailAddress() {
    if (this.email) {
      let lastChars = this.email.lastIndexOf(".");
      let expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
      if (!expression.test(String(this.email).toLowerCase()) || this.email.substr(lastChars, 3).length < 3) {
        return 0;
      }
      else {
        return 1;
      }
    }
    return;
  }

  numbersOnly($event: any) {
    if ($event.target.value.length === 0) {
      if ($event.key === '0' || $event.key === '1' || $event.key === '2' || $event.key === '3' || $event.key === '4' || $event.key === '5') {
        return false;
      }
    }
    let reg = /^[0-9]+$/;
    return (reg.test($event.key));
  };

  onKeyDown(event: KeyboardEvent) {
    if (event.keyCode === 32) {
      const inputValue = (event.target as HTMLInputElement).value;
      if (inputValue.endsWith(' ')) {
        event.preventDefault();
      }
    }
  }

  generateUniqueUrl(mobile: any, nid: any) {
    const uniquePart = mobile+'-'+nid;
   this.uuid = this._encryptionService.generateMd5Hash(uniquePart);
    let url = window.location.href
    let parsedUrl = new URL(url);
    parsedUrl.searchParams.delete('utm_source');
    parsedUrl.searchParams.delete('utm_campaign');
    parsedUrl.searchParams.delete('utm_medium');

    let baseUrl = parsedUrl.origin + parsedUrl.pathname;
    const uniqueUrl = `${baseUrl}?eventkey=${this.uuid}`;
    return uniqueUrl;
  }
  // Registrations process End Here 

  scrollUp() {
    window.scrollTo({
      top: 20,
      behavior: 'smooth',
    })
  }

  GetParameterValues(param: string) {
    let url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (const element of url) {
      let urlparam = element.split('=');
      if (urlparam[0] == param) {
        return urlparam[1];
      }
    }
    return;
  }


}
